
import { Vue, Component, Prop } from "vue-property-decorator";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";

@Component({
  components: { DropdownInput }
})
export default class DocumentChooserFilters extends Vue {
  @Prop()
  sortBy!: string;

  @Prop()
  postType!: string;

  sortItems = [
    { text: "Last edited: Newest first", value: "modified_desc" },
    { text: "Last edited: Oldest first", value: "modified_asc" },
    { text: "Created: Newest first", value: "created_desc" },
    { text: "Created: Oldest first", value: "created_asc" }
  ];

  postTypeOptions = {
    populate: {
      path: "",
      text: "",
      value: "",
      fetchDataAction: "breakdance_get_editable_post_types",
      fetchContextPath: "",
      refetchPaths: []
    }
  };
}
